import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";
import type { CalloutContent } from "@/types/report";

interface Props {
  content: CalloutContent;
}

export function CalloutSection({ content }: Props) {
  return (
    <div className={`report-callout ${content.style}`}>
      {content.heading && <h3>{content.heading}</h3>}
      <Markdown remarkPlugins={[remarkGfm]}>{content.text}</Markdown>
    </div>
  );
}
